"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Nav = _interopRequireDefault(require("./Nav.render"));
var _breakPoints = require("../../constants/breakPoints");
var _fetchNavigationItems = _interopRequireDefault(require("../../utils/fetchNavigationItems"));
var _getLocaleFromPreferences = _interopRequireDefault(require("../../utils/getLocaleFromPreferences"));
var _navigationCache = _interopRequireDefault(require("../../utils/navigationCache"));
var _pssSurveyMutations = require("../../utils/pssSurveyMutations");
var _fetchNavigationBanner = _interopRequireDefault(require("../../utils/fetchNavigationBanner"));
var _checkBannerToggle = _interopRequireDefault(require("../../utils/checkBannerToggle"));
var _SessionBanner = _interopRequireDefault(require("../../components/SessionBanner"));
var _useScreenSize = require("../../components/hooks/useScreenSize");
let navFetch;
let bannerFetch;
let unmounted = false;
const Nav = _ref => {
  let {
    appConfig,
    data,
    logTimeToRender,
    authReady,
    authFail,
    authRetry = () => {},
    headerApi,
    preferencesFromNetwork,
    ModalComp
  } = _ref;
  const [nav, setNav] = (0, _react.useState)({});
  const [banner, setBanner] = (0, _react.useState)({});
  const [fetchNavError, setFetchNavError] = (0, _react.useState)(false);
  const [fetchBannerError, setFetchBannerError] = (0, _react.useState)(false);
  const [shouldDisplayBanner, setShouldDisplayBanner] = (0, _react.useState)(false);
  const locale = (0, _getLocaleFromPreferences.default)(data);
  const {
    bff: bffUrl
  } = appConfig.urls;
  const {
    hp2Migrate
  } = (data === null || data === void 0 ? void 0 : data.preferences) || {};
  const navDataLoaded = navData => {
    if (typeof window.onIcisSharedHeaderLoaded === 'function') window.onIcisSharedHeaderLoaded(true);
    setFetchNavError(false);
    setNav(navData);
    navFetch = null;
  };
  const onNavLoadFail = e => {
    setFetchNavError(true);
    if (typeof window.onIcisSharedHeaderLoaded === 'function') {
      window.onIcisSharedHeaderLoaded(false);
    }
  };
  const onBannerLoadFail = e => {
    setFetchBannerError(true);
    if (typeof window.onIcisSharedHeaderLoaded === 'function') {
      window.onIcisSharedHeaderLoaded(false);
    }
  };
  const fetchAndSetNav = async () => {
    /* istanbul ignore if */if (!locale || navFetch) return;
    try {
      navFetch = (0, _fetchNavigationItems.default)({
        locale,
        bffUrl
      });
      const fetchedNav = await navFetch;
      _navigationCache.default.save({
        items: fetchedNav,
        locale,
        hp2Migrate
      });
      navDataLoaded({
        menuItems: fetchedNav,
        locale,
        hp2Migrate
      });
    } catch (e) {
      navFetch = null;
      onNavLoadFail(e);
    }
  };
  const getBannerData = async () => {
    /* istanbul ignore if */if (!locale || bannerFetch) return;
    try {
      bannerFetch = (0, _fetchNavigationBanner.default)({
        bffUrl
      });
      const fetchedBanner = await bannerFetch;
      setBanner(fetchedBanner);
      setFetchNavError(false);
    } catch (e) {
      onBannerLoadFail(e);
    }
  };
  (0, _react.useEffect)(() => () => {
    unmounted = true;
  }, []);
  (0, _react.useEffect)(() => {
    const navAlreadyLoaded = nav.menuItems && nav.locale === locale && nav.hp2Migrate === hp2Migrate;
    const hasUserAndPreferences = data.preferences && data.user;
    const isReadyToLoadNavItems = hasUserAndPreferences && authReady && locale !== undefined;
    if (navAlreadyLoaded || navFetch || !isReadyToLoadNavItems) {
      return;
    }
    const cachedNav = _navigationCache.default.load({
      locale,
      hp2Migrate
    });
    /* istanbul ignore next */
    if (cachedNav) {
      navDataLoaded({
        menuItems: cachedNav,
        locale,
        hp2Migrate
      });
    } else {
      if (process.env.NODE_ENV === 'development') {
        fetchAndSetNav();
      }
      // the component is mounted and unmounted so we need to trigger this fetch after this behavior in standalone version
      // this is quick hack before a proper fix for pilet version as well
      /* eslint-disable no-lonely-if */
      if (headerApi.isPilet) {
        fetchAndSetNav();
      } else if (unmounted) {
        fetchAndSetNav();
      }
    }
  }, [data, authReady, hp2Migrate]);
  (0, _react.useEffect)(() => {
    var _data$application;
    const isNavLoaded = nav.locale && nav.menuItems && nav.hp2Migrate === hp2Migrate;
    const shouldDisplayBannerFromLocalStorage = localStorage.getItem('showSessionBanner') === 'true';
    const shouldDisplayBannerFromServer = (0, _checkBannerToggle.default)(((_data$application = data.application) === null || _data$application === void 0 ? void 0 : _data$application.toggles) || []);
    const shouldDisplayBannerBasedOnServer = shouldDisplayBannerFromLocalStorage && shouldDisplayBannerFromServer;
    setShouldDisplayBanner(shouldDisplayBannerBasedOnServer);
    if (isNavLoaded && shouldDisplayBannerBasedOnServer) getBannerData();
  }, [data.application, nav]);
  (0, _react.useEffect)(() => {
    var _data$preferences;
    if (!((_data$preferences = data.preferences) !== null && _data$preferences !== void 0 && _data$preferences.pssSurveyLastSeen) || data.loading || !preferencesFromNetwork) return;
    const {
      pssSurveyLastSeen,
      pssSurveyLastCompleted
    } = data.preferences;
    const runQualtricsChecks = () => {
      var _window$QSI;
      const qualtricsApi = (_window$QSI = window.QSI) === null || _window$QSI === void 0 ? void 0 : _window$QSI.API;
      if (!qualtricsApi) return;
      qualtricsApi.unload();
      qualtricsApi.load().then(() => {
        qualtricsApi.run();
      });
    };
    const handlePssSurveyInteraction = mutation => {
      window.icisPssSurvey.hasBeenShown = true;
      mutation();
    };
    window.icisPssSurvey = {
      pssSurveyLastSeen,
      pssSurveyLastCompleted,
      setPssSurveyLastSeen: () => handlePssSurveyInteraction(_pssSurveyMutations.setPssSurveyLastSeenMutation),
      setPssSurveyLastCompleted: () => handlePssSurveyInteraction(_pssSurveyMutations.setPssSurveyCompletedMutation)
    };
    runQualtricsChecks();
  }, [data.preferences, data.loading, preferencesFromNetwork]);
  const {
    windowWidth
  } = (0, _useScreenSize.useScreenSize)();
  const isMobile = windowWidth <= _breakPoints.MAX_HAMBURGER_WIDTH;
  const isUserAndPreferencesData = data.preferences !== undefined && data.user !== undefined;
  const isUserAndPreferencesError = data.error && !isUserAndPreferencesData;
  const isNavigationData = nav.menuItems !== undefined;
  const isNavigationError = fetchNavError && nav.menuItems === undefined;
  const isError = authFail || isUserAndPreferencesError || isNavigationError;
  const isDataLoading = !isError && (!authReady || !isNavigationData || !isUserAndPreferencesData);
  let reloadFn = fetchAndSetNav;
  if (isUserAndPreferencesError) reloadFn = data.refetch;
  if (authFail) reloadFn = authRetry;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Nav.default, {
    menuItems: nav.menuItems,
    fetchError: isError,
    reload: () => reloadFn(),
    isLoading: isDataLoading,
    logTimeToRender: logTimeToRender,
    ModalComp: ModalComp
  }), !isError && !fetchBannerError && shouldDisplayBanner && /*#__PURE__*/_react.default.createElement(_SessionBanner.default, {
    isMobile: isMobile,
    locale: locale,
    banner: banner,
    ModalComp: ModalComp
  }));
};
var _default = exports.default = Nav;